var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_45",
    "data-name": "Group 45",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.998,
    height: 38.998,
    viewBox: "0 0 38.998 38.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M19.5,0A19.5,19.5,0,1,1,0,19.5,19.5,19.5,0,0,1,19.5,0Z",
    fill: "#161c2e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 4.959, 20.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 21.516,
    height: 21.516,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons",
    transform: "translate(4.001 4.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M7.875,12.33l5.355-5.4a.855.855,0,0,0,0-1.26L7.875.27A.945.945,0,0,0,6.66.18a.855.855,0,0,0-.09,1.35L10.44,5.4H.9a.9.9,0,0,0,0,1.8h9.54L6.57,11.07a.855.855,0,0,0,.09,1.35.945.945,0,0,0,1.215-.09Z",
    transform: "translate(0 0)",
    fill: "#7d828f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ba8114a01587b7a0ec4c7097b760267f.svg";
export { ForwardRef as ReactComponent };